import React from "react";

const Loader = ({ forProducts = false }: any) => {
  return <div className={`${forProducts ? 'PLoader' : 'loader'}`} />;
};

export default Loader;
